import axios from "axios";
import config from "../config";

// Every client gets `config.requestTimeout`. Axios defaults to NO timeout, so
// without it a stalled connection — the external ABDM gateway above all — hangs
// forever and the awaiting screen never leaves its loading state.
const TIMEOUT_MESSAGE =
  "The request timed out. Please check your connection and try again.";

/**
 * Turns axios's opaque "timeout of 30000ms exceeded" into something a screen can
 * show, and flags it so callers can tell a timeout from a real HTTP failure.
 * The rejection is still the axios error, so `err.response` keeps its meaning.
 */
const surfaceTimeout = (error) => {
  if (error && error.code === "ECONNABORTED") {
    error.isTimeout = true;
    error.message = TIMEOUT_MESSAGE;
  }
  return Promise.reject(error);
};

const axiosInstance = axios.create({
  baseURL: `${config.backend.baseUrl}/api`,
  timeout: config.requestTimeout,
});

//  Add authorization header to all requests
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

const axiosABHAInstance = axios.create({
  baseURL: config.abdm.baseUrl,
  timeout: config.requestTimeout,
});

//  Add authorization header to all requests of ABHA flow
axiosABHAInstance.interceptors.request.use((config) => {
  config.headers["content-type"] = `application/json`;
  config.headers["Accept"] = "application/json";

  return config;
});

[axiosInstance, axiosABHAInstance].forEach((client) =>
  client.interceptors.response.use((response) => response, surfaceTimeout)
);

export { axiosABHAInstance, TIMEOUT_MESSAGE };

export default axiosInstance;
